'use-client';
import * as React from 'react';
import type { IPopupRootProps } from '../../../PopupRoot.types';
import styles from '../../style/ResponsivePopupRoot.scss';
import PopupRoot from '../../PopupRoot';

const ResponsiveLinkBar: React.FC<Omit<IPopupRootProps, 'styles'>> = props => {
  return <PopupRoot {...props} styles={styles} />;
};

export default ResponsiveLinkBar;
